"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authService = void 0;
const firebaseBase_1 = require("./firebaseBase");
const unifiedFirestoreService_1 = require("./unifiedFirestoreService");
/**
 * Auth Service
 * Handles user authentication, profile management, and preferences
 * Now uses async Firebase manager for reliable initialization
 */
class AuthService {
    /**
     * Extract first name from display name for username generation
     */
    extractFirstName(displayName) {
        var _a;
        if (!displayName)
            return 'user';
        // Split on common separators and take first part
        const parts = displayName.split(/[\s\-_\.]+/);
        const firstName = (_a = parts[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim();
        // Remove non-alphanumeric characters but keep basic letters/numbers
        const cleaned = (firstName === null || firstName === void 0 ? void 0 : firstName.replace(/[^a-zA-Z0-9]/g, '')) || 'user';
        // Ensure minimum length
        return cleaned.length >= 2 ? cleaned : 'user';
    }
    /**
     * Generate unique username based on first name
     */
    generateUniqueUsername(baseName) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const cleanBaseName = this.extractFirstName(baseName);
                // Check if base name is available using unified collection
                const baseSnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                    .where('username', '==', cleanBaseName)
                    .getDocs();
                if (baseSnapshot.length === 0) {
                    return cleanBaseName;
                }
                // Try numbered variants
                for (let i = 1; i <= 999; i++) {
                    const candidate = `${cleanBaseName}${i}`;
                    const candidateSnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                        .where('username', '==', candidate)
                        .getDocs();
                    if (candidateSnapshot.length === 0) {
                        return candidate;
                    }
                }
                // Fallback with timestamp
                return `${cleanBaseName}${Date.now().toString().slice(-4)}`;
            }), 'generateUniqueUsername');
        });
    }
    /**
     * Validate username format and availability
     */
    validateUsername(username, currentUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            // Format validation
            if (!username || username.length < 2) {
                return { isValid: false, message: 'Username must be at least 2 characters long' };
            }
            if (username.length > 20) {
                return { isValid: false, message: 'Username must be 20 characters or less' };
            }
            if (!/^[a-zA-Z0-9_]+$/.test(username)) {
                return { isValid: false, message: 'Username can only contain letters, numbers, and underscores' };
            }
            // Check availability using unified collection
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const snapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                    .where('username', '==', username.toLowerCase())
                    .getDocs();
                // If no documents found, username is available
                if (snapshot.length === 0) {
                    return { isValid: true };
                }
                // If current user owns this username, it's valid
                if (currentUserId && ((_a = snapshot[0]) === null || _a === void 0 ? void 0 : _a.id) === currentUserId) {
                    return { isValid: true };
                }
                return { isValid: false, message: 'Username is already taken' };
            }), 'validateUsername');
        });
    }
    /**
     * Get user profile
     */
    getUserProfile(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                console.log('🔄 AuthService: Getting user profile for:', userId);
                // Check if running on native platform (iOS/Android)
                const isNative = typeof window.Capacitor !== 'undefined' &&
                    ((_b = (_a = window.Capacitor).isNativePlatform) === null || _b === void 0 ? void 0 : _b.call(_a));
                if (isNative) {
                    console.log('📱 AuthService: Using NATIVE Firestore for iOS/Android');
                    const { nativeFirestoreAdapter } = yield Promise.resolve().then(() => __importStar(require('./nativeFirestoreAdapter')));
                    const result = yield nativeFirestoreAdapter.getDocument(`userProfiles/${userId}`);
                    if (result) {
                        const profile = result.data;
                        // Ensure username exists with fallback (no DB writes to avoid permission issues)
                        if (!profile.username) {
                            const fallbackUsername = ((_c = profile.displayName) === null || _c === void 0 ? void 0 : _c.toLowerCase().replace(/\s+/g, '')) ||
                                ((_e = (_d = profile.email) === null || _d === void 0 ? void 0 : _d.split('@')[0]) === null || _e === void 0 ? void 0 : _e.toLowerCase()) ||
                                'user';
                            profile.username = fallbackUsername.replace(/^@/, '');
                            console.log('🔧 AuthService: Using fallback username for display:', profile.username);
                        }
                        console.log('✅ AuthService: Retrieved user profile:', {
                            displayName: profile.displayName,
                            username: profile.username,
                            updatedAt: profile.updatedAt
                        });
                        return profile;
                    }
                    console.log('⚠️ AuthService: No user profile found for:', userId);
                    return null;
                }
                else {
                    // Use unified Firestore for cross-platform support
                    const userDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', userId);
                    if (userDoc.exists()) {
                        const profile = userDoc.data();
                        // Ensure username exists with fallback (no DB writes to avoid permission issues)
                        if (!profile.username) {
                            // Generate a fallback username without trying to save it
                            const fallbackUsername = ((_f = profile.displayName) === null || _f === void 0 ? void 0 : _f.toLowerCase().replace(/\s+/g, '')) ||
                                ((_h = (_g = profile.email) === null || _g === void 0 ? void 0 : _g.split('@')[0]) === null || _h === void 0 ? void 0 : _h.toLowerCase()) ||
                                'user';
                            profile.username = fallbackUsername.replace(/^@/, '');
                            console.log('🔧 AuthService: Using fallback username for display:', profile.username);
                        }
                        console.log('✅ AuthService: Retrieved user profile:', {
                            displayName: profile.displayName,
                            username: profile.username,
                            updatedAt: profile.updatedAt
                        });
                        return profile;
                    }
                    console.log('⚠️ AuthService: No user profile found for:', userId);
                    return null;
                }
            }), 'getUserProfile');
        });
    }
    /**
     * Get lightweight user profile (for performance-critical operations)
     */
    getUserProfileLite(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                console.log('🔄 AuthService: Getting lite user profile for:', userId);
                // Check if Firebase is initialized first
                try {
                    // Use unified Firestore for cross-platform support
                    const userDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', userId);
                    if (userDoc.exists()) {
                        const profile = userDoc.data();
                        // For lite version, ensure username exists with fallback
                        if (!profile.username) {
                            profile.username = ((_a = profile.displayName) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace(/\s+/g, '')) ||
                                ((_c = (_b = profile.email) === null || _b === void 0 ? void 0 : _b.split('@')[0]) === null || _c === void 0 ? void 0 : _c.toLowerCase()) ||
                                'user';
                        }
                        console.log('✅ AuthService: Retrieved lite user profile:', {
                            displayName: profile.displayName,
                            username: profile.username
                        });
                        return profile;
                    }
                    console.log('⚠️ AuthService: No lite user profile found for:', userId);
                    return null;
                }
                catch (initError) {
                    console.error('❌ AuthService: Firebase not initialized yet for getUserProfileLite:', initError);
                    throw initError;
                }
            }), 'getUserProfileLite');
        });
    }
    /**
     * Create user profile
     */
    createUserProfile(user, additionalData = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                // Use Google account display name as-is
                const displayName = additionalData.displayName || user.displayName || ((_a = user.email) === null || _a === void 0 ? void 0 : _a.split('@')[0]) || 'User';
                // Generate username from first name only, unless specific username provided
                let baseUsername;
                if (additionalData.username) {
                    baseUsername = additionalData.username;
                }
                else {
                    baseUsername = this.extractFirstName(displayName);
                }
                const uniqueUsername = yield this.generateUniqueUsername(baseUsername);
                // Import access control constants
                const { USER_ROLES, FOUNDING_ADMIN_UIDS, getWaitlistEnabled } = yield Promise.resolve().then(() => __importStar(require('../constants/index')));
                // Determine initial role for new user
                const initialRole = FOUNDING_ADMIN_UIDS.includes(user.uid)
                    ? USER_ROLES.ADMIN
                    : getWaitlistEnabled()
                        ? USER_ROLES.PENDING
                        : USER_ROLES.REGULAR;
                const userData = {
                    uid: user.uid,
                    email: user.email || '',
                    displayName: displayName,
                    username: uniqueUsername,
                    photoURL: user.photoURL || undefined,
                    bio: additionalData.bio,
                    location: additionalData.location,
                    website: additionalData.website,
                    favoriteGenres: additionalData.favoriteGenres || [],
                    socialLinks: additionalData.socialLinks,
                    privacy: {
                        profileVisibility: ((_b = additionalData.privacy) === null || _b === void 0 ? void 0 : _b.profileVisibility) || 'public',
                        showWatchlist: (_d = (_c = additionalData.privacy) === null || _c === void 0 ? void 0 : _c.showWatchlist) !== null && _d !== void 0 ? _d : true,
                        showRatings: (_f = (_e = additionalData.privacy) === null || _e === void 0 ? void 0 : _e.showRatings) !== null && _f !== void 0 ? _f : true,
                        showActivity: (_h = (_g = additionalData.privacy) === null || _g === void 0 ? void 0 : _g.showActivity) !== null && _h !== void 0 ? _h : true,
                    },
                    stats: {
                        moviesWatched: 0,
                        reviewsWritten: 0,
                        listsCreated: 0,
                        followersCount: 0,
                        followingCount: 0,
                        likesReceived: 0,
                    },
                    role: initialRole,
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString(),
                };
                console.log('🔐 Creating user profile:', { username: uniqueUsername, displayName, role: initialRole });
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('userProfiles', user.uid, userData);
                // Auto-create access request for pending users (waitlist)
                if (initialRole === USER_ROLES.PENDING) {
                    try {
                        const { accessControlService } = yield Promise.resolve().then(() => __importStar(require('./accessControlService')));
                        console.log('📋 Auto-creating access request for new pending user:', user.uid);
                        yield accessControlService.createAccessRequest(user.uid, user.email || '', displayName, user.photoURL || undefined);
                        console.log('✅ Access request auto-created for user:', user.uid);
                    }
                    catch (accessRequestError) {
                        // Don't fail user creation if access request fails
                        console.error('⚠️ Failed to auto-create access request:', accessRequestError);
                    }
                }
                // Auto-follow Watchlist Crew account for new users
                try {
                    const { SYSTEM_ACCOUNTS } = yield Promise.resolve().then(() => __importStar(require('../constants/index')));
                    const { socialService } = yield Promise.resolve().then(() => __importStar(require('./socialService')));
                    console.log('🔗 Auto-following Watchlist Crew for new user:', user.uid);
                    yield socialService.followUser(user.uid, SYSTEM_ACCOUNTS.WATCHLIST_CREW_UID);
                    console.log('✅ Successfully auto-followed Watchlist Crew');
                }
                catch (followError) {
                    // Don't fail user creation if auto-follow fails
                    console.error('⚠️ Failed to auto-follow Watchlist Crew:', followError);
                }
            }), 'createUserProfile');
        });
    }
    /**
     * Update user profile
     */
    updateUserProfile(userId, updates) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Handle username changes
                if (updates.username) {
                    const isAvailable = yield this.checkUsernameAvailability(updates.username, userId);
                    if (!isAvailable) {
                        throw new Error('Username is already taken');
                    }
                }
                const updateData = Object.assign(Object.assign({}, updates), { updatedAt: new Date().toISOString() });
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', userId, updateData);
                console.log('✅ AuthService: User profile updated successfully');
            }), 'updateUserProfile');
        });
    }
    /**
     * Search users
     */
    searchUsers(searchTerm, limitCount = 10) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                if (!searchTerm || searchTerm.length < 2) {
                    return [];
                }
                const searchTermLower = searchTerm.toLowerCase();
                // Search by display name and username using unified collection
                const [displayNameSnapshot, usernameSnapshot] = yield Promise.all([
                    (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                        .where('displayName', '>=', searchTerm)
                        .where('displayName', '<=', searchTerm + '\uf8ff')
                        .getDocs(),
                    (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                        .where('username', '>=', searchTermLower.startsWith('@') ? searchTermLower : `@${searchTermLower}`)
                        .where('username', '<=', (searchTermLower.startsWith('@') ? searchTermLower : `@${searchTermLower}`) + '\uf8ff')
                        .getDocs()
                ]);
                const results = new Map();
                displayNameSnapshot.forEach(doc => {
                    const profile = doc.data();
                    results.set(profile.uid, profile);
                });
                usernameSnapshot.forEach(doc => {
                    const profile = doc.data();
                    results.set(profile.uid, profile);
                });
                return Array.from(results.values()).slice(0, limitCount);
            }), 'searchUsers');
        });
    }
    /**
     * Check username availability
     */
    checkUsernameAvailability(username, excludeUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Normalize username (lowercase, NO @ symbol)
                const normalizedUsername = username.toLowerCase().replace(/^@/, '');
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                    .where('username', '==', normalizedUsername)
                    .getDocs();
                if (querySnapshot.length === 0) {
                    return true;
                }
                // If excludeUid is provided, check if the only match is the user we're excluding
                if (excludeUid) {
                    return querySnapshot.length === 1 && querySnapshot[0].data().uid === excludeUid;
                }
                return false;
            }), 'checkUsernameAvailability');
        });
    }
    /**
     * Generate username suggestions
     */
    generateUsernameSuggestions(baseUsername) {
        return __awaiter(this, void 0, void 0, function* () {
            const suggestions = [];
            for (let i = 1; i <= 5; i++) {
                const suggestion = `${baseUsername}${i}`;
                const isAvailable = yield this.checkUsernameAvailability(suggestion);
                if (isAvailable) {
                    suggestions.push(`@${suggestion}`);
                }
            }
            return suggestions.slice(0, 3);
        });
    }
    /**
     * User preferences management
     */
    saveUserPreferences(user, preferences) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const existingPreferences = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userPreferences', user.uid);
                const preferencesData = Object.assign(Object.assign(Object.assign({ uid: user.uid }, existingPreferences.exists() ? existingPreferences.data() : {}), preferences), { updatedAt: new Date().toISOString() });
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('userPreferences', user.uid, preferencesData);
            }), 'saveUserPreferences');
        });
    }
    getUserPreferences(user) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                // Check if running on native platform (iOS/Android)
                const isNative = typeof window.Capacitor !== 'undefined' &&
                    ((_b = (_a = window.Capacitor).isNativePlatform) === null || _b === void 0 ? void 0 : _b.call(_a));
                if (isNative) {
                    console.log('📱 AuthService: Using NATIVE Firestore for getUserPreferences');
                    const { nativeFirestoreAdapter } = yield Promise.resolve().then(() => __importStar(require('./nativeFirestoreAdapter')));
                    const result = yield nativeFirestoreAdapter.getDocument(`userPreferences/${user.uid}`);
                    return result ? result.data : null;
                }
                else {
                    // Use unified Firestore for cross-platform support
                    const preferencesDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userPreferences', user.uid);
                    return preferencesDoc.exists() ? preferencesDoc.data() : null;
                }
            }), 'getUserPreferences');
        });
    }
    createUserPreferences(user, preferences = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const now = new Date().toISOString();
                const defaultPreferences = Object.assign({ uid: user.uid, theme: 'system', language: 'en', preferredLanguages: ['en'], notifications: {
                        push: true,
                        newFollowers: true,
                        watchlistActivity: true,
                        collaborationActivity: true,
                        watchVoiceAdds: true,
                        reviewLikes: true,
                    }, privacy: {
                        profileDiscoverable: true,
                        showActivity: true,
                        allowRecommendations: true,
                        profileVisibility: 'public',
                    }, onboardingCompleted: false, preferredGenres: [], contentFilters: {
                        hideAdult: false,
                        hideViolence: false,
                    }, defaultWatchlistPrivacy: 'public', homeWatchlistViewMode: 'grid', otherUserProfileViewMode: 'grid', createdAt: now, updatedAt: now }, preferences);
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('userPreferences', user.uid, defaultPreferences);
            }), 'createUserPreferences');
        });
    }
    updateUserPreferences(uid, updates) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userPreferences', uid, Object.assign(Object.assign({}, updates), { updatedAt: new Date().toISOString() }));
            }), 'updateUserPreferences');
        });
    }
    deleteUserPreferences(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('userPreferences', uid);
            }), 'deleteUserPreferences');
        });
    }
    /**
     * Initialize user data (profile + preferences)
     */
    initializeUserData(user) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                yield Promise.all([
                    // this.initializeUserProfile(user), // TODO: implement this method
                    this.createUserPreferences(user),
                ]);
            }), 'initializeUserData');
        });
    }
    /**
     * Delete user account and all associated data.
     * Deletes the Firebase Auth account last — this fires the onUserDeleted Cloud Function,
     * which cascade-deletes all remaining Firestore data and Storage assets.
     */
    deleteUserAccount(user, _password) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Delete Firebase Auth account. The onUserDeleted Cloud Function handles
                // all Firestore + Storage cleanup as a server-side cascade.
                yield user.delete();
                console.log('✅ User account deleted — onUserDeleted trigger will clean up remaining data');
            }), 'deleteUserAccount');
        });
    }
    /**
     * Utility methods
     */
    isPasswordProvider(user) {
        return user.providerData.some(provider => provider.providerId === 'password');
    }
    filterUserProfileForPrivacy(user) {
        const { privacy } = user;
        if (privacy.profileVisibility === 'private') {
            return Object.assign(Object.assign({}, user), { bio: undefined, location: undefined, website: undefined, socialLinks: undefined });
        }
        return user;
    }
}
// Export singleton instance
exports.authService = new AuthService();
exports.default = exports.authService;
